import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { toast } from "react-toastify";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";
import { useMyContext } from "../../../components/Provider/CommonProvider";

const LiveCategoryAddEdit = ({ isModal = false, onSuccess, forceCreate = false }) => {

    const { id } = useParams()
    const isEditing = !!id && !forceCreate
    const navigate = useNavigate();
    const { globalImageUplaodAPI, fetchRequest } = useMyContext()

    const customHeader = getItemToken('access_token')

    const baseURL = process.env.REACT_APP_Baseurl
    const labelSource = 'livestream-category'

    const createApi = `${baseURL}/admin/livestream/category-create`
    const addApi = `${baseURL}/admin/livestream/category-store`
    const imageApi = globalImageUplaodAPI()
    const editApi = `${baseURL}/admin/livestream/category-edit`
    const updateApi = `${baseURL}/admin/livestream/category-update`

    const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`

    const [labelDisplay, setLabelDisplay] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        slug: '',
        parent_id: '',
        home_genre: '',
        in_home: 0,
        in_menu: 0,
        footer: 0,
        banner: 0,
        parent_category: 1
    })
    const [formDataError, setFormDataError] = useState({})
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [bannerImageFile, setBannerImageFile] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [defaultOption, setDefaultOption] = useState({
        state: "defaultOption",
        parentOption: [],
    })

    const [customFieldValues, setCustomFieldValues] = useState({})
    const combinedRef = useRef({
        name: null,
        slug: null,
        description: null,
        details: null,
        rating: null,
        age_restrict: null
    });

    const handleBlurtitle = () => {
        if (!formData?.slug) {
            generateSlug(formData?.name);
        }
    };
    const generateSlug = async (name) => {
        const slug = await slugGenerator(name)
        setFormData((prev) => ({
            ...prev,
            'slug': slug,
        }));
    };
    const handleInputKeyDowntitle = (event) => {
        if (!formData?.slug) {
            if (event.key === "Enter" || event.key === "Tab") {
                generateSlug(formData?.name);
            }
        }
    };
    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            setFormData((prev) => ({
                ...prev,
                [name]: checked ? 1 : 0,
            }));
        }
        if (type === 'text') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
        if (type === 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
        setFormDataError((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const focusInput = (inputName) => {
        if (combinedRef.current[inputName]) {
            combinedRef.current[inputName].focus();
        }
    };

    const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const ratio = width / height;
                const expectedRatioPrecision = 0.01;
                const ratioMatch = Math.abs(ratio - expectedRatio) < expectedRatioPrecision;
                const dimensionMatch = (width === expectedWidth && height === expectedHeight);
                if (ratioMatch || dimensionMatch) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
            img.onerror = () => {
                toast.error('Error loading image');
                // reject(new Error('Error loading image'));
            };
        });
    };

    const handleFileChange = async (event) => {
        const { files, name, value, accept } = event.target
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));

        if (files?.length > 0) {
            const newFile = files[0];
            const reader = new FileReader();
            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };
            const fileContent = await readFile(newFile);

            if (!allowedTypes.includes(files[0]?.type)) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only JPG, JPEG, and PNG files are allowed.",
                }));
                if (name === 'image') setCoverImageFile(null);
                if (name === 'banner_image') setBannerImageFile(null);
                return;
            }

            if (name == 'image') {
                setCoverImageFile(newFile);
                const isValidSize = await validateImageRatio(newFile, 1 / 1, 1080, 1080);

                if (!isValidSize) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 1:1 Ratio or 1080x1080px.",
                    }));
                }
            }
            if (name == 'banner_image') {
                setBannerImageFile(newFile);
                const isValidSize = await validateImageRatio(newFile, 16 / 9, 1280, 720);

                if (!isValidSize) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 16:9 Ratio or 1280x720px.",
                    }));
                }
            }
        }
    };

    const handleClearSelectFile = (value) => {
        if (value == 'image') {
            setCoverImageFile(null)
        }
        else {
            setBannerImageFile(null)
        }
    }


    const fetchDefault = async () => {
        const reponse = await axios.get(`${createApi}`, { headers: customHeader, })
            .then((response) => {
                var result = response?.data?.LiveCategories;
                setDefaultOption((prev) => ({
                    ...prev,
                    parentOption: result
                }))
            })
            .catch((error) => console.log(error));
    }

    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.name || formData?.name.trim().length < 3 || formData?.name.trim().length > 100) {
            toast.error("Name must be between 3 and 100 characters.");
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                name: "Title cannot be empty or contain only spaces.",
            }));
            combinedRef.current['name'].focus()
            formIsValid = false;
        }

        if (!formData?.slug || formData?.slug.trim().length < 3 || formData?.slug.trim().length > 100) {
            toast.error("Slug must be between 3 and 100 characters.");
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                slug: "Slug cannot be empty or contain only spaces.",
            }));
            combinedRef.current['slug'].focus()
            formIsValid = false;
        }
        return formIsValid;
    }

    const handleFileUpload = async (storeid) => {
        try {
            const formDataAdd = new FormData();
            formDataAdd.append('id', storeid);
            formDataAdd.append('modelName', 'LiveCategory');
            formDataAdd.append('image', coverImageFile);
            if(bannerImageFile) formDataAdd.append('banner_image', bannerImageFile);
            formDataAdd.append('imageFields[]', 'image');
            if(bannerImageFile) formDataAdd.append('imageFields[]', 'banner_image');

            try {
                const response = await fetchRequest({ method: 'POST', url: imageApi, data: formDataAdd });
            }
            catch (err) {
                toast.error(err?.response?.data?.message || err.message)
            }
            setCoverImageFile(null)
            setBannerImageFile(null)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "slug", "parent_id", "home_genre", "in_home", "in_menu", "footer", "banner"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            if (formData?.parent_category === 1) {
                formDataAdd.parent_id = null
            }
            const response = await axios.post(`${addApi}`, formDataAdd, { headers: customHeader });
            const result = response?.data;
            if (result?.status) {
                // save custom field values (strict)
                try {
                    await saveCustomFieldsStrict({ baseURL, headers: customHeader, entityType: 'live_category', entityId: result?.LiveCategories?.id, values: customFieldValues });
                } catch (e) {
                    toast.error(e?.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (coverImageFile || bannerImageFile) {
                    await handleFileUpload(result?.LiveCategories?.id)
                }
                setShowOverlay(false);
                toast.success(result?.message)
                if (typeof onSuccess === 'function') {
                    onSuccess(result?.LiveCategories?.id, formData?.name);
                } else {
                    navigate("/livestream-categories");
                }
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }
    }

    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "slug", "parent_id", "home_genre", "in_home", "in_menu", "footer", "banner"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            if (formData?.parent_category === 1) {
                formDataAdd.parent_id = null
            }
            const response = await axios.patch(`${updateApi}/${id}`, formDataAdd, { headers: customHeader });
            const result = response?.data;
            if (result?.status) {
                // save custom field values (strict)
                try {

                    await saveCustomFieldsStrict({ baseURL, headers: customHeader, entityType: 'live_category', entityId: id, values: customFieldValues });
                } catch (e) {
                    toast.error(e?.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (coverImageFile || bannerImageFile) {
                    await handleFileUpload(id)
                }
                setShowOverlay(false);
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }
    }

    const handleStore = () => {
        if (formValidation()) {
            if (!isEditing) {
                handleAdd()
            }
            else {
                handleUpdate()
            }
        }
    }

    const labelFetch = async () => {
        try {
            setShowOverlay(true)
            const response = await axios.get(`${labelApi}`, { headers: customHeader });
            const result = response?.data?.label_management
            setLabelDisplay(result)
            setShowOverlay(false)
        }
        catch (err) {
            setShowOverlay(false)
            toast.error(err.response.data.message)

        }
    }

    const fetchEditData = () => {
        const reponse = axios.get(`${editApi}/${id}`, { headers: customHeader, })
            .then((response) => {
                var result = response?.data?.LiveCategories;
                setFormData(result)
            })
            .catch((error) => console.log(error));
    }


    useEffect(async () => {
        await fetchDefault()
        await labelFetch()
    }, [])

    useEffect(async () => {
        if (id && !forceCreate) {
            await fetchEditData()
        }
    }, [withOutRefresh, id, forceCreate]);

    function flattenCategories(list, level = 0, result = []) {
        list.forEach(item => {
            const indent = '\u00A0\u00A0\u00A0\u00A0'.repeat(level); // padding
            const prefix = level ? '• ' : '';

            result.push({
                id: item.id,
                label: `${indent}${prefix}${item.name}`, // for dropdown list
                name: item.name                           // clean name
            });

            if (item.sub_category?.length) {
                flattenCategories(item.sub_category, level + 1, result);
            }
        });
        return result;
    }
    const flatOptions = flattenCategories(defaultOption?.parentOption || []);

    return (
        <>
            {showOverlay && (<Response_Processing></Response_Processing>)}
            {!isModal && <AdminBackNavigation path={`/livestream-categories`} text="Back" />}
            {!isModal && <AdminSaveHeader id={"live-category-save-button"} heading={!isEditing ? labelDisplay?.[0]?.title : labelDisplay?.[10]?.title} saveText={labelDisplay?.[9]?.title} saveMethod={handleStore} />}
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        {!isEditing ? <MessageHeading text={labelDisplay?.[1]?.title} /> : ""}
                        <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
                        <AdminCustomInput id={"live-category-name"} type="text" name="name" value={formData?.name} onChange={handleInput} placeHolder={"Name"} ref={(el) => (combinedRef.current.name = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.name} />

                        <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                        <AdminCustomInput id={"live-category-slug"} type="text" name="slug" value={formData?.slug} onChange={handleInput} placeHolder={"slug"} ref={(el) => (combinedRef.current.slug = el)} error={formDataError?.slug} />

                        <MessageLabel text={labelDisplay?.[4]?.title || "Home Genre"} />
                        <AdminCustomInput id="live-category-home-genre" type="text" name="home_genre" value={formData?.home_genre} ref={(el) => (combinedRef.current.home_genre = el)} onChange={handleInput} placeHolder={"Home genre"} error={formDataError?.home_genre} />
                        
                        <FormContainer>
                            <div className="col-7 col-md-7 pe-2">
                                <MessageLabel text={"Make as Parent Category"} />
                            </div>
                            <div className="col-5 col-md-5 ps-2 text-end">
                                <AdminSwitch id="retain-value" name="parent_category" checked={Number(formData?.parent_category) === 1} onChange={handleInput} />
                            </div>
                        </FormContainer>
                        
                        {Number(formData?.parent_category) === 0 && <>
                            <MessageLabel text={"Select Parent Category"} />
                            <select
                                name="parent_id"
                                value={formData?.parent_id || ""}
                                onChange={handleInput}
                                className="custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color"
                            >
                                <option value="">Choose a category</option>
                                {flatOptions.map(opt => (
                                    <option className="theme-bg-color theme-text-color" key={opt.id} value={opt.id}>{opt.label}</option>
                                ))}
                            </select>
                            {formDataError?.parent_id && (
                                <p className="text-danger">{formDataError.parent_id}</p>
                            )}
                        </>}

            <div className="card p-3 mt-3">
                            {/* <MessageHeading text="Additional Fields" /> */}
                            {/* Custom fields */}
                            <FieldRenderer2
                                pageIdentifier={id ? "live_category.edit" : "live_category.create"}
                                entityType="live_category"
                                entityId={id}
                                text="Additional Fields"
                            />
                            <FieldRenderer
                                pageIdentifier={id ? "live_category.edit" : "live_category.create"}
                                entityType="live_category"
                                entityId={id}
                                onChange={setCustomFieldValues}
                            />
                        </div>
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay[5]?.title || "Images"} />
                        <MessageLabel text={labelDisplay[6]?.title || "Cover Image"} className="" />
                        <p className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Select the image( 1:1 Ratio or 1080x1080px )</p>
                        <AdminImageUploadZone onChange={handleFileChange} selectedFile={coverImageFile} uploadedImage={formData?.image_url} onDelete={handleClearSelectFile} ref={(el) => (combinedRef.current.image = el)} name="image" idAttribute={"live-category-image"} id={isEditing ? id : undefined} accept="image/jpeg,image/png,image/jpg" error={formDataError?.image} />
                        
                        <MessageLabel text={"Banner Image"} className="" />
                        <p className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Select the image( 16:9 Ratio or 1280x720px )</p>
                        <AdminImageUploadZone onChange={handleFileChange} selectedFile={bannerImageFile} uploadedImage={formData?.banner_image_url} onDelete={handleClearSelectFile} ref={(el) => (combinedRef.current.banner_image = el)} name="banner_image" idAttribute={"live-category-banner-image"} id={isEditing ? id : undefined} accept="image/jpeg,image/png,image/jpg" error={formDataError?.banner_image} />
                    </Wrapper>

                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[7]?.title || 'Status'} />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"In Home"} className="" />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch id={"live-category-in-home"} name={"in_home"} checked={formData?.in_home == 1} onChange={handleInput} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={labelDisplay[8]?.title || "In Menu"} className="" />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch id={"live-category-in-menu"} name={"in_menu"} checked={formData?.in_menu == 1} onChange={handleInput} />
                            </div>
                        </div>
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton id={"live-category-store-button"} className='px-3 py-1 m-0 ms-auto' saveMethod={handleStore} saveText={labelDisplay[9]?.title} />
            </FormContainer>
        </>
    );
};
export default LiveCategoryAddEdit;